<template>
  <div>
    <v-form @submit.prevent v-model="valid">
      <v-text-field
        v-model="client_id"
        label="Client ID"
        required
        outlined
        :disabled="loading"
        :rules="[(v) => !!v || 'Client ID é obrigatório']"
      />
      <v-text-field
        v-model="client_secret"
        label="Client Secret"
        required
        outlined
        :disabled="loading"
        :rules="[(v) => !!v || 'Client Secret é obrigatório']"
      />
      <v-text-field
        v-model="access_token"
        label="Access Token (aplicativo)"
        required
        outlined
        :disabled="loading"
        :rules="[(v) => !!v || 'Access Token é obrigatório']"
      />

      <v-alert v-if="error" type="error" text>
        {{ error }}
      </v-alert>

      <v-alert type="info" text class="mb-3">
        Configure as credenciais do <strong>aplicativo</strong> Mercado Pago
        (painel → Sua aplicação → Credenciais). Em desenvolvimento, use as
        <strong>credenciais de teste</strong> e conecte a organização com uma
        <strong>conta de teste vendedor</strong>. Não há servidor sandbox
        separado: o ambiente (live/test) vem das credenciais usadas no OAuth e
        no Access Token.
      </v-alert>

      <v-btn
        color="primary"
        @click="save"
        :disabled="!valid"
        :loading="loading"
      >
        Salvar
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import platformService from "@/services/admin/platform";

export default {
  name: "MercadoPagoSettings",
  props: {
    platform: {
      type: Object,
      required: true,
    },
    gateways: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      valid: false,
      loading: false,
      client_id: "",
      client_secret: "",
      access_token: "",
    };
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        this.error = null;
        await platformService.updateGateway(this.platform.id, "mercadopago", {
          client_id: this.client_id,
          client_secret: this.client_secret,
          access_token: this.access_token,
        });
        this.$emit("update:valid", true);
      } catch (error) {
        this.error = error.message || "Erro ao salvar configurações";
        this.$emit("update:valid", false);
      } finally {
        this.loading = false;
      }
    },
    load() {
      const mp = this.gateways?.mercadopago || {};
      this.client_id = mp.client_id || "";
      this.client_secret = mp.client_secret || "";
      this.access_token = mp.access_token || "";
      this.$emit(
        "update:valid",
        !!mp.client_id && !!mp.client_secret && !!mp.access_token
      );
    },
  },
  watch: {
    gateways: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
  },
};
</script>
